/**
 * @generated SignedSource<<0bb6d41d156ae8db20a91e0862454e8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "AUDIT_ACTOR" | "AUDIT_ACTOR_SOURCE" | "AUDIT_APPROVAL_TYPE" | "AUDIT_BATCH_ID" | "AUDIT_EVENT_DATE" | "AUDIT_EVENT_TYPE" | "AUDIT_FIELD_NAME" | "AUDIT_FROM_STATUS" | "AUDIT_IS_MATERIAL" | "AUDIT_TIME_TYPE" | "AUDIT_TO_STATUS" | "AUDIT_WORK_DATE" | "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "PROJECT_STAGE_PROFILE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type ProjectRelayWrapperV2RefetchQuery$variables = {
  pageSize?: number | null;
  searchQuery?: TaskSearchQueryType | null;
  reportId?: string | null;
  sharedId?: string | null;
};
export type ProjectRelayWrapperV2RefetchQuery$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectRelayWrapperV2_viewer">;
  } | null;
};
export type ProjectRelayWrapperV2RefetchQuery = {
  variables: ProjectRelayWrapperV2RefetchQuery$variables;
  response: ProjectRelayWrapperV2RefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharedId"
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_relay_wrapper_v2"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_relay_wrapper_v2\")"
},
v5 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v6 = {
  "kind": "Variable",
  "name": "sharedId",
  "variableName": "sharedId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "points",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectRelayWrapperV2RefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              {
                "kind": "Variable",
                "name": "reportId",
                "variableName": "reportId"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectRelayWrapperV2_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectRelayWrapperV2RefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "reportId"
              },
              (v6/*: any*/)
            ],
            "concreteType": "ReportData",
            "kind": "LinkedField",
            "name": "reportData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "ReportProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyProjectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customProjectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "readOnlyAccess",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReportTaskTotals",
                            "kind": "LinkedField",
                            "name": "taskTotals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskReportTableTask_GroupWork",
                                "kind": "LinkedField",
                                "name": "work",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskReportTableTask_Unit",
                                    "kind": "LinkedField",
                                    "name": "estimate",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskReportTableTask_Unit",
                                    "kind": "LinkedField",
                                    "name": "remaining",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskReportTableTask_Reported",
                                "kind": "LinkedField",
                                "name": "reported",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "time",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projected",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReportTotalsFinancial",
                                "kind": "LinkedField",
                                "name": "financial",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskReportTableTask_Revenue",
                                    "kind": "LinkedField",
                                    "name": "revenue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "planned",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "actual",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalTimeAtCompletion",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billablePlannedTimeAndExpenses",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualTimeAndExpenses",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableForecastTimeAndExpensesToComplete",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableTotalTimeAndExpensesAtCompletion",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalForecastRevenueToComplete",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalRevenueRecognition",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "surplus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entities",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": [
                  "searchQuery"
                ],
                "handle": "connection",
                "key": "TaskReport_projects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20363baa7a7f8e80010e8b29e55d4a85",
    "id": null,
    "metadata": {},
    "name": "ProjectRelayWrapperV2RefetchQuery",
    "operationKind": "query",
    "text": "query ProjectRelayWrapperV2RefetchQuery(\n  $pageSize: Int\n  $searchQuery: TaskSearchQueryType\n  $reportId: String\n  $sharedId: String\n) {\n  viewer {\n    component(name: \"project_relay_wrapper_v2\")\n    ...ProjectRelayWrapperV2_viewer_3tSDRy\n    id\n  }\n}\n\nfragment ProjectRelayWrapperV2_viewer_3tSDRy on Viewer {\n  reportData(id: $reportId, sharedId: $sharedId) {\n    projects(first: $pageSize, searchQuery: $searchQuery) {\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n      edges {\n        node {\n          id\n          projectId\n          companyProjectId\n          customProjectId\n          name\n          projectColor\n          readOnlyAccess\n          taskTotals {\n            work {\n              estimate {\n                minutes\n                points\n              }\n              remaining {\n                minutes\n                points\n              }\n            }\n            reported {\n              time\n              projected\n            }\n            financial {\n              revenue {\n                planned\n                actual\n              }\n              billableActualMinutes\n              nonBillableActualMinutes\n              totalTimeAtCompletion\n              billablePlannedTimeAndExpenses\n              billableActualTimeAndExpenses\n              billableForecastTimeAndExpensesToComplete\n              billableTotalTimeAndExpensesAtCompletion\n              totalForecastRevenueToComplete\n              totalRevenueRecognition\n              surplus\n            }\n            entities\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "af65a680bb6419e9ae5b5577dc94f77c";

export default node;
